import StayStudyPage from "../components/StayStudyPage";

export default function Stay7() {
  return (
    <StayStudyPage
      className="Class 7"
      heroTitle="Class 7 Stay & Study Program"
      heroDescription="An academically focused residential program that strengthens concepts, discipline, and independent learning skills."

      section1={{
        title: "📘 Advanced Concept Building",
        description:
          "Class 7 introduces analytical thinking and deeper subject understanding.",
        points: [
          "STATE|CBSE-aligned curriculum coverage",
          "Strong focus on Maths, Science & Languages",
          "Concept explanation with real-life examples",
          "Regular revision and practice tests",
          "Doubt-clearing sessions with mentors"
        ]
      }}

      section2={{
        title: "🗓️ Structured Academic Routine",
        description:
          "A disciplined daily schedule builds focus, time management, and academic consistency.",
        points: [
          "Supervised morning & evening study hours",
          "Homework guidance and revision time",
          "Balanced academics and relaxation",
          "Improved concentration and self-study habits",
          "Distraction-free learning environment"
        ]
      }}

      whyUs={{
        title: "⭐ Why Choose ACCESS Stay & Study for Class 7?",
        description:
          "We help students transition smoothly into higher academic expectations.",
        points: [
          "Experienced middle-school faculty",
          "24/7 supervised residential campus",
          "Daily monitored study sessions",
          "Regular assessments & performance tracking",
          "Individual mentoring and guidance",
          "Safe hostel with nutritious meals",
          "Focus on discipline and confidence building"
        ]
      }}

      images={{
        section1: "/images/class9-1.jpg",
        section2: "/images/class9-2.jpg",
        whyUs: "/images/Hostel2.jpeg"
      }}

      fee="75,000"
      whatsappText="Hello ACCESS Team, I would like to enquire about the Class 7 Stay & Study Program."
    />
  );
}
